import React from 'react';
import { useTranslation } from 'react-i18next';
import { Divider } from '@mui/material';
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';

import RabenLogo from 'src/images/raben-logo.png';
import Logo from 'src/views/components/Logo';
import { LogosContainer, Subtitle, Title } from './index.styles';

export default function Header() {
  const { t } = useTranslation();
  return (
    <>
      <LogosContainer>
        <Box sx={{ ml: '40px', mt: '12px' }}>
          <Link to="/">
            <Logo width={195} height={52} />
          </Link>
        </Box>
        <Divider
          orientation="vertical"
          flexItem
          sx={{ ml: '40px', mr: '8px', borderRightWidth: '2px' }}
        />
        <img src={RabenLogo} width="266px" height="120px" />
      </LogosContainer>
      <Title>{t('registration_raben.title')}</Title>
      <Subtitle>{t('registration_raben.subtitle')}</Subtitle>
    </>
  );
}
